// extracted by mini-css-extract-plugin
export default {"wrapper":"confirm-modal_wrapper__P7ZjU","footer":"confirm-modal_footer__WJ-MR","main_wrapper":"confirm-modal_main_wrapper__37kfq"};